import React from 'react';
import { tr } from '../../i18n';
import { ImageUploader } from './ImageUploader';

export const CategoriesEditor = ({ draft, lang, t, uploadPhoto, resolveImg, updateMainCategoryImage, updateSubCategoryImage }) => {
  return (
    <div className="space-y-8">
      {/* Main categories */}
      <section className="bg-white border-[1.5px] border-black rounded-[16px] p-5 md:p-6">
        <h2 className="font-display text-2xl md:text-3xl text-black mb-1">
          {lang === 'it' ? 'Categorie principali' : 'Main categories'}
        </h2>
        <p className="text-xs text-black/60 mb-5">
          {lang === 'it' ? 'Le 3 tab che si vedono in home.' : 'The 3 tabs visible on home.'}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          {draft.mainCategories.map((cat) => (
            <div key={cat.slug} className="border-[1.5px] border-black/15 rounded-2xl p-4">
              <p className="font-display text-xl text-black mb-2 truncate">{tr(cat.name, lang)}</p>
              <ImageUploader
                value={cat.image}
                onChange={(v) => updateMainCategoryImage(cat.slug, v)}
                onUpload={(file) => uploadPhoto(file, (url) => updateMainCategoryImage(cat.slug, url))}
                resolveImg={resolveImg}
                t={t}
              />
            </div>
          ))}
        </div>
      </section>

      {/* Sub categories grouped by main */}
      {draft.mainCategories.map((cat) => (
        <section key={cat.slug} className="bg-white border-[1.5px] border-black rounded-[16px] p-5 md:p-6">
          <h2 className="font-display text-2xl md:text-3xl text-black mb-1">
            {lang === 'it' ? 'Sezioni di ' : 'Sections of '} <span className="italic">{tr(cat.name, lang)}</span>
          </h2>
          <p className="text-xs text-black/60 mb-5">
            {lang === 'it' ? 'Le sotto‑tab che compaiono cliccando la categoria.' : 'Sub‑tabs shown after tapping the category.'}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {(draft.subCategories[cat.slug] || []).map((sub) => (
              <div key={sub.slug} className="border-[1.5px] border-black/15 rounded-2xl p-4">
                <p className="font-display text-lg text-black mb-2 truncate">{tr(sub.name, lang)}</p>
                <ImageUploader
                  value={sub.image}
                  onChange={(v) => updateSubCategoryImage(cat.slug, sub.slug, v)}
                  onUpload={(file) => uploadPhoto(file, (url) => updateSubCategoryImage(cat.slug, sub.slug, url))}
                  resolveImg={resolveImg}
                  t={t}
                />
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default CategoriesEditor;
